class AccountsController implements ng.IComponentController {

    constructor() {
        'ngInject';
        // console.log('AccountsController');
    }
}

export const accountsComponent : ng.IComponentOptions = {
    controller : AccountsController,
    template : require('./accounts.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/accounts/accounts.component.ts